import { useTranslation } from "react-i18next";
import { useRecoilState, useResetRecoilState } from "recoil";
import Validator from "fastest-validator";
import {
  myHrAddPermissionValidFromState,
  myHrAddPermissionValidToState,
} from "my-hr/states";
import { ocAddPermissionEmailState } from "oc/states";

const validator = new Validator();

export const useMyHrPermissionForm = () => {
  const { t } = useTranslation();

  const schema = {
    email: {
      type: "email",
      messages: {
        email: t("MY_HR_ERROR_MESSAGE_WRONG_EMAIL_FORMAT"),
        emailEmpty: t("OC_ERROR_MESSAGE_EMAIL_IS_REQUIRED"),
      },
    },
    validFrom: {
      type: "date",
    },
    validTo: [
      {
        type: "date",
        optional: true,
      },
      {
        type: "string",
        optional: true,
      },
    ],
  };

  const check = validator.compile(schema);

  const [email, setEmail] = useRecoilState(ocAddPermissionEmailState);
  const [validFrom, setValidFrom] = useRecoilState(
    myHrAddPermissionValidFromState,
  );
  const [validTo, setValidTo] = useRecoilState(myHrAddPermissionValidToState);

  const onChangeEmail = (value: string) => {
    setEmail({ value, error: false, errorText: "" });
  };

  const onChangeValidFrom = (date: Date | string) => {
    setValidFrom({ value: date });
  };

  const onChangeValidTo = (date: Date | string) => {
    setValidTo({ value: date });
  };

  const isValid = async () => {
    let isValidated = await check({
      email: email.value,
      validFrom: validFrom.value,
      validTo: validTo.value,
    });

    if (isValidated !== true) {
      isValidated.forEach((item: any) => {
        if (item.field === "email") {
          setEmail({
            value: email.value,
            error: true,
            errorText: item.message,
          });
        }
      });
      return false;
    }
    return true;
  };

  const resetAddPermissionEmailState = useResetRecoilState(
    ocAddPermissionEmailState,
  );
  const resetmyHrAddPermissionValidFromState = useResetRecoilState(
    myHrAddPermissionValidFromState,
  );
  const resetmyHrAddPermissionValidToState = useResetRecoilState(
    myHrAddPermissionValidToState,
  );

  const onClear = () => {
    resetAddPermissionEmailState();
    resetmyHrAddPermissionValidFromState();
    resetmyHrAddPermissionValidToState();
  };

  const onClearError = () => {
    setEmail({ value: email.value, error: false, errorText: "" });
  };

  return {
    email,
    setEmail,
    isValid,
    onChangeEmail,
    onChangeValidFrom,
    onChangeValidTo,
    onClear,
    onClearError,
    validFrom,
    validTo,
  };
};

export default useMyHrPermissionForm;
